// Equipment Out of Service / back in service: the reason + who reported it travel with the status (status_reason /
// status_by), and the database writes the maintenance history line + diary line from them (sql/consistency.sql).
// Shared by the Equipment page dialog; the AI (api/_agent.js proposeStatus) follows the same rule.
import { actorName } from './fleetCore.js'   // a manager inside a vessel writes the company's name (fleet-1)

// null = no dialog; { required } = ask for a reason (required when going Out of Service)
export function statusReasonAsk(from, to) {
  const was = String(from || '').trim(), now = String(to || '').trim()
  if (!now || now === was) return null
  if (now === 'Out of Service') return { required: true }
  if (was === 'Out of Service') return { required: false }
  return null
}

// the logged-in name, as the change history / AI cards write it
export function reportedByDefault(config) {
  if (!config) return ''
  return actorName(config)
}

// the extra fields for the save (equipment form uses display names, see src/lib/api.js)
export function statusReasonFields(reason, by) {
  const out = {}
  const r = String(reason || '').trim(), b = String(by || '').trim()
  if (r) out['Status Reason'] = r.slice(0, 300)
  if (b) out['Status By'] = b.slice(0, 80)
  return out
}
